module.exports = __webpack_public_path__ + "img/md-item07.4484db8.png";